export default class ArenaTariffOption {
    OptionCode: number = 0;
    Name: string = '';
    Price: number = 0;
}